<template>
    <div v-show="query !== ''">
        <ais-instant-search
            :search-client="searchClient"
            :index-name="index"
            :search-function="searchFunction"
            :middlewares="middlewares"
            :routing="routing"
        >
            <ais-configure
                :query="query"
                :filters="searchFilters"
            />

            <!-- Filters -->
            <filter-panel-mobile :filters="categoryFilters"/>

            <div class="row">
                <filter-panel
                    :filters="categoryFilters"
                    class="col-12 col-md-4 col-lg-3 algolia-listing-filters d-none d-md-block"
                />
                <algolia-search-results
                    page-type="Search"
                    :lang-iso="langIso"
                    :user-token="userToken"
                    :action-banners="[]"
                    :curation-banner="curationContext.banner"
                    class="col-12 col-md-8 col-lg-9"
                />
            </div>

            <algolia-search-no-results/>
        </ais-instant-search>
    </div>
</template>

<script>
import {
    algoliaClientShortTTL,
    index,
} from "../../js/algoliaSettings";
import AlgoliaSearchResults from "./AlgoliaSearchResults";
import AlgoliaSearchNoResults from "./AlgoliaSearchNoResults";
import FilterPanelMobile from "./Partials/FilterPanelMobile";
import FilterPanel from "./Partials/FilterPanel";
import { AisConfigure, AisInstantSearch, AisRefinementList, AisStats } from "vue-instantsearch/vue3/es";
import { history as historyRouter } from "instantsearch.js/es/lib/routers";
import { AlgoliaSearchHelper } from "algoliasearch-helper";
import qs from "qs";

const normalizeFilter = (filter = {}) => {
    const normalized = {};

    for (const property in filter) {
        const item = filter[property];
        normalized[property] = Array.isArray(item) ? item : [item].filter(Boolean);
    }

    return normalized;
};
import { fetchCurationContext, composeSearchFilters } from "../../js/curationRules";

const changeDisplayOnComponents = (type = "hide") => {
    const displayStyle = type === "show" ? "block" : "none";

    if (document.getElementById("center_column")) {
        document.getElementById("center_column").style.display = displayStyle;
    }

    if (document.getElementById("right-column")) {
        document.getElementById("right-column").style.display = displayStyle;
    }

    if (document.getElementById("js_mobileMenuHome")) {
        document.getElementById("js_mobileMenuHome").style.display = displayStyle;
    }

    if (typeof is_mobile !== "undefined") {
        if (is_mobile) {
            if (document.getElementById("brekz_topmenu")) {
                document.getElementById(
                    "brekz_topmenu"
                ).style.display = displayStyle;
            }

            const menuTops = document.getElementsByClassName("menu-top");
            Array.from(menuTops).forEach(el => {
                el.style.display = displayStyle;
            });

            const usps = document.getElementsByClassName("usps");
            Array.from(usps).forEach(el => {
                el.style.display = displayStyle;
            });
        }
    }
};

export default {
    components: {
        AisInstantSearch,
        AisRefinementList,
        AisStats,
        AisConfigure,
        AlgoliaSearchResults,
        AlgoliaSearchNoResults,
        FilterPanel,
        FilterPanelMobile
    },
    props: {
        categoryFilters: {
            type: Array,
            required: true,
            default: () => []
        },
        categoryId: {
            type: Number,
            required: false,
            default: 0
        },
        langIso: {
            type: String,
            required: false,
            default: 'nl-NL',
        },
        userPersonalisationIdentifier: {
            type: Number,
            required: false,
            default: null,
        }
    },
    computed: {
        searchFilters() {
            return composeSearchFilters(undefined, this.curationContext);
        }
    },
    data() {
        // Filters present on the URL when the page loads, kept around so they
        // survive being written back to the address bar even for attributes
        // that don't have a mounted refinement-list widget on this page.
        const initialRefinementList = normalizeFilter(
            qs.parse(window.location.search.slice(1)).filter
        );

        return {
            curationContext: { banner: null, hiddenIds: [], exclusiveIds: null },
            searchClient: algoliaClientShortTTL(),

            /** @param {AlgoliaSearchHelper} helper */
            searchFunction(helper) {
                if (helper.state.query && helper.state.query !== "") {
                    const oldSearchQuery = localStorage.getItem('brekz_algolia_search_query');
                    if (helper.state.query !== oldSearchQuery
                        && oldSearchQuery !== null
                        && this.hasSearchedBefore) {
                        helper.clearRefinements();
                    }

                    let params = new URLSearchParams(window.location.search);

                    if (params.has('disableCache') && params.get('disableCache') == '1') {
                        localStorage.removeItem('algoliasearch-client-js-responses-cache');
                        localStorage.removeItem('algoliasearch-client-js-responses-cache-short');
                    }


                    this.hasSearchedBefore = true;
                    try {
                        localStorage.setItem('brekz_algolia_search_query', helper.state.query);
                    } catch(e) {
                        console.log(e);
                        helper.search();
                        return;
                    }
                    helper.search();
                }
            },
            index: index(),
            userToken: null,
            hasSearchedBefore: false,
            query: "",
            routing: {
                router: historyRouter({

                    createURL({ qsModule, routeState, location }) {

                        const queryParameters = {};

                        const searchParams = new URLSearchParams(location.search);

                        if (searchParams.has("query")) {
                            queryParameters.query = searchParams.get("query");
                        } else if (routeState.query) {
                            queryParameters.query = encodeURIComponent(routeState.query);

                        }

                        if (routeState.page !== 1) {
                            queryParameters.page = routeState.page;
                        }

                        if (routeState.refinementList) {
                            queryParameters.filter = routeState.refinementList;
                        }

                        const queryString = qsModule.stringify(queryParameters, {
                            addQueryPrefix: true,
                            arrayFormat: 'repeat'
                        });

                        return `${queryString}`;
                    },

                    parseURL({ qsModule, location }) {

                        const { query = '', page, filter = {} } = qsModule.parse(
                            location.search.slice(1)
                        );

                        return {
                            query: decodeURIComponent(query),
                            page,
                            refinementList: normalizeFilter(filter),
                        };
                    }
                }),
                stateMapping: {
                    stateToRoute(uiState) {
                        const indexUiState = uiState[index()] || {};

                        return {
                            query: indexUiState.query,
                            page: indexUiState.page,
                            refinementList: {
                                ...initialRefinementList,
                                ...indexUiState.refinementList,
                            },
                        };
                    },
                    routeToState(routeState) {
                        return {
                            [index()]: {
                                query: routeState.query,
                                page: routeState.page,
                                refinementList: routeState.refinementList
                            }
                        };
                    }
                },
            }
        };
    },
    mounted() {
        const applySearchQuery = query => {
            if (query === null || query === "") {
                this.query = "";
                changeDisplayOnComponents("show");

                if (document.getElementsByTagName('body')[0].getAttribute('id') !== 'category') {
                    if (document.getElementById("orders-button-bottom")) {
                        document.getElementById("orders-button-bottom").classList.remove('d-none');
                    }
                    if (document.getElementById("filters-button-bottom")) {
                        document.getElementById("filters-button-bottom").classList.add('d-none');
                    }
                }
            } else {
                this.query = query;
                changeDisplayOnComponents("hide");


                if (document.getElementById("orders-button-bottom")) {
                    document.getElementById("orders-button-bottom").classList.add('d-none');
                }

                if (document.getElementById("filters-button-bottom")) {
                    document.getElementById("filters-button-bottom").classList.remove('d-none');
                }
            }

            fetchCurationContext({ trigger: this.query || null, categoryId: null }).then(ctx => {
                this.curationContext = ctx;
            });
        };

        EventBus.$on("search-input-hit", applySearchQuery);

        // Deep-linking: a shared/typed URL already carries the query (and any
        // filter[...] params), so activate the search state immediately
        // instead of waiting on the header search box to (re-)emit it.
        const initialQuery = new URLSearchParams(window.location.search).get("query");
        if (initialQuery !== null && initialQuery !== "") {
            applySearchQuery(initialQuery);
        }
    }
};
</script>
